import React from 'react';
import './Cases.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Cases = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="cases" id="cases">
      <div className="cases-title">
        <h2 className="cases-heading">{t.casesTitle}</h2>
      </div>
      
      <div className="cases-cards">
        <a href="#corporate-training" className="cases-card">
          <div className="cases-card-title">
            <div className="cases-card-logo">
              <img 
                src="/logos/logo-alt-university.png" 
                alt="ALT University"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<span style="font-size: 12px; color: #2C2B2F; font-weight: bold;">ALT</span>';
                }}
              />
            </div>
            <div className="cases-card-logo-text">
              <h3 className="cases-card-company">ALT University</h3>
            </div>
          </div>
          <div className="cases-card-image">
            <img 
              src="/images/case-alt-university.jpg" 
              alt="ALT University Case"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.background = '#232226';
              }}
            />
          </div>
          <div className="cases-card-slider">
            <div className="cases-card-dot active"></div>
            <div className="cases-card-dot inactive"></div>
            <div className="cases-card-dot inactive"></div>
          </div>
        </a>

        <a href="#kmg-card" className="cases-card">
          <div className="cases-card-title">
            <div className="cases-card-logo">
              <img 
                src="/logos/logo-kmg.png" 
                alt="KMG Engineering"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<span style="font-size: 12px; color: #2C2B2F; font-weight: bold;">KMG</span>';
                }}
              />
            </div>
            <div className="cases-card-logo-text">
              <h3 className="cases-card-company">KMG Engineering</h3>
            </div>
          </div>
          <div className="cases-card-image">
            <img 
              src="/images/case-kmg-engineering.jpg" 
              alt="KMG Engineering Case"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.background = '#232226';
              }}
            />
          </div>
          <div className="cases-card-slider">
            <div className="cases-card-dot active"></div>
            <div className="cases-card-dot inactive"></div>
            <div className="cases-card-dot inactive"></div>
          </div>
        </a>

        <a href="#kegoc-card" className="cases-card">
          <div className="cases-card-title">
            <div className="cases-card-logo">
              <img 
                src="/logos/logo-kegoc.png" 
                alt="KEGOC"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<span style="font-size: 12px; color: #2C2B2F; font-weight: bold;">KE</span>';
                }}
              />
            </div>
            <div className="cases-card-logo-text">
              <h3 className="cases-card-company">KEGOC</h3>
            </div>
          </div>
          <div className="cases-card-image">
            <img 
              src="/images/case-kegoc.jpg" 
              alt="KEGOC Case"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.background = '#232226';
              }}
            />
          </div>
          <div className="cases-card-slider">
            <div className="cases-card-dot active"></div>
            <div className="cases-card-dot inactive"></div>
            <div className="cases-card-dot inactive"></div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Cases;
